import { ReactElement, useContext } from 'react';
import { GroupBase, MenuListProps } from 'react-select';
import { FormFieldLayoutContext } from '../FormFieldLayout/FormFieldLayoutContext';
import { classes } from './Multiselect';

const CustomMenuList = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MenuListProps<Option, IsMulti, Group>
): ReactElement => {
  const { children, className, cx, isMulti, innerRef, selectProps } = props;
  const listId = `multiselect-list-${selectProps.instanceId}`;
  const layoutContext = useContext(FormFieldLayoutContext);
  const layoutClasses = classes({ modifiers: layoutContext ? layoutContext.layout : '', extra: className });
  return (
    <div
      className={cx(
        {
          'menu-list': true,
          'menu-list--is-multi': isMulti,
        },
        layoutClasses.className
      )}
      ref={innerRef}
      aria-expanded="true"
      role="listbox"
      id={listId}
    >
      {children}
    </div>
  );
};

export default CustomMenuList;
